import { LOCATION_WINTER } from 'app/constants/AppConstants';

export default class ClothItem extends Phaser.Group {
  constructor(game, data, listRef) {
    super(game);

    /* data
    {
      "id": 0,
      "description": "orange jacket",
      "skin_name": "outfit_01",
      "image_key": "outfit_01"
    }
    */
    this.data = data;
    this.listRef = listRef;
    this.charData = null; // character outfit data

    // hanger
    this.hanger = this.game.make.image(0, 0, 'ui_dress_up', 'hanger');
    this.hanger.anchor.set(0.5, 0);
    this.addChild(this.hanger);

    this.startX = 0;
    this.startY = 0;
    this.isDown = false;

    // cloth
    this.btn = this.game.make.button(0, 30, 'ui_dress_up');
    this.btn.frameName = this.data.image_key;
    this.btn.anchor.set(0.5, 0);
    this.btn.events.onInputDown.add(this.handleInputDown, this);
    this.btn.events.onInputUp.add(this.handleInputUp, this);
    this.addChild(this.btn);
  }

  enable() {
    this.btn.input.enabled = true;
  }

  disable() {
    this.btn.input.enabled = false;
  }

  handleInputDown(target, pointer) {
    target;
    pointer;

    this.pointer = pointer;
    this.isDown = true;
    this.startX = pointer.x;
    this.startY = pointer.y;
  }

  handleInputUp() {
    if (this.isDown) {
      this.wearCloth();
    }
  }

  dragCloth() {
    this.btn.visible = false;
    this.isDown = false;

    this.game.state
      .getCurrentState()
      .startDragCloth(this, this.charData ? this.charData : this.data, this.pointer);
  }

  wearCloth() {
    this.isDown = false;
    this.game.state.getCurrentState().stopDragCloth(
      {
        slotRef: this,
        clothData: this.charData ? this.charData : this.data,
        worldPosition: new Phaser.Point(),
      },
      true
    );
  }

  update() {
    // start drag
    if (this.isDown) {
      const dx = Math.abs(this.pointer.x - this.startX);
      const dy = Math.abs(this.pointer.y - this.startY);
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist > 20) {
        this.dragCloth();
      }
    }

    //
    super.update();
  }

  showCharacterCloth(characterId) {
    this.charData = this.game.controller.gameData.clothes.find((d) => d.character === characterId);

    let frameName = 'outfit_' + characterId;
    if (characterId === 'olive' && this.game.controller.location === LOCATION_WINTER) {
      frameName += '_winter';
    }
    this.btn.frameName = frameName;

    this.btn.visible = true;
    this.btn.input.enabled = true;
  }

  resetOutfit() {
    this.charData = null;
    this.btn.frameName = this.data.image_key;
    this.btn.visible = true;
    this.btn.input.enabled = true;
  }

  returnOutfit() {
    this.btn.visible = true;
  }

  getWP() {
    const x = this.btn.worldPosition.x;
    const y = this.btn.worldPosition.y + this.btn.height * 0.5;
    return { x: x, y: y };
  }

  pulse() {
    this.pulseTween = this.game.add
      .tween(this.btn.scale)
      .to({ x: [1.1, 1], y: [1.1, 1] }, 800, Phaser.Easing.BackOut, true, 0);
    this.pulseTween.onComplete;
  }

  stopPulse() {
    if (this.pulseTween) {
      this.pulseTween.stop();
      this.pulseTween = false;
      this.btn.scale.set(1);
    }
  }
}
